import React from "react";

import { TicketService } from "@egis-smartcity/parking";

export type TicketState = {
  ticketService?: TicketService;
};

export const TicketContext = React.createContext<TicketState | undefined>(
  undefined
);

export default TicketContext;
